import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Loadersspinners from './Loaders/LoadersSpinners'; 
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { cartItem } from '../features/cartdata';
import { useSnackbar } from 'notistack';
import Payment from './Payment'
import Button from 'react-bootstrap/esm/Button';
import { Baseurl } from '../constants/env';

const Orderform = () => {
  const {userid} = useSelector((state)=>state.auth);
  const location = useLocation();
  const {totalprice} = location.state;

  const dispatch = useDispatch();
  const navigate = useNavigate();
 
  const[Loading,setLoading]=useState(false);

   const[adress,setAdress]=useState();
   const[phone,setPhone]=useState();
   const[radio,setRadio]=useState();

   const{enqueueSnackbar} = useSnackbar();


   const handlePayment = async (event) => {

    function loadScript(src) {
      return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => {
              resolve(true);
          };
          script.onerror = () => {
              resolve(false);
          };
          document.body.appendChild(script);
      });
  }

    if (!totalprice || isNaN(totalprice) || totalprice <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    const backendURL = `${Baseurl}`

    try {
      const currency = 'INR';
      const receiptId = '1234567890';

      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
    }

      const { data } = await axios.post(`${backendURL}/onlinePay`, {totalprice,currency,receiptId});

      var option = {
        key:"rzp_test_kk3oYss2Ku6gIs",
        amount:data.amount,
        currency,
        name:"Sam Joseph",
        description: "Test Transaction",
        image:"https://i.ibb.co/5Y3m33n/test.png",
        order_id:data.id,
        handler: async function(response) {
          const body = {...response,}
          const validateResponse = await axios.post('http://localhost:5001/validate',body)
          if(validateResponse.status == 200){
            alert('Your payment is success')
            let data = {
              userid,
              totalprice,
              adress,
              mobile:phone,
              radio:'online',
              validateResponse
        }
        axios.post('http://localhost:5001/placeorder',data,{withCredentials:true}).then((resp)=>{
        setLoading(true);
         if(resp.status === 200){
           dispatch(cartItem(0));
           localStorage.setItem('cart',0)
           enqueueSnackbar('Order Succesfully Placed',{variant:'success'});
           setLoading(false);
          return navigate('/orders',{replace:true})
         }
   
        }).catch((e)=>{
         console.log(e);
         setLoading(false);
         enqueueSnackbar('Enter Required Fields ',{variant:'error'});
        })
          }

          if(validateResponse.status != 200 || !validateResponse?.status){
            alert('Your payment is failed try agiain later')
          }
          
        },
        prefill: {
          name: "Sam Joseph", 
          email: "samjoseph97.19@gmail.com",
          contact: "9000000000", 
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
      }
      // const paymentObject = new window.Razorpay(option);
      // paymentObject.open();
      var rzp1 = new window.Razorpay(option);
      rzp1.on("payment.failed", function(response) {
        alert(response.error.code);
        alert(response.error.description);
        alert(response.error.source);
        alert(response.error.step);
        alert(response.error.reason);
        alert(response.error.metadata.order_id);
        alert(response.error.metadata.payment_id);
      })

      rzp1.open();
      event.preventDefault();
    } catch (error) {
      console.error("Payment Failed:", error);
      alert("Payment Failed. Please try again.");
    }
  };

   async function submitdata(e){
     e.preventDefault();
     if(radio === 'online'){
      return
     }
     setLoading(true)
     //console.log(adress,phone,radio);
   
     let data = {
           userid,
           totalprice,
           adress,
           mobile:phone,
           radio
     }
     await axios.post(`${Baseurl}/placeorder`,data,{withCredentials:true}).then((resp)=>{
     // console.log(resp);
     setLoading(true);
      if(resp.status === 200){
        dispatch(cartItem(0));
        localStorage.setItem('cart',0)
        enqueueSnackbar('Order Succesfully Placed',{variant:'success'});
        setLoading(false);
       return navigate('/Profile/userorders',{replace:true})
      }

     }).catch((e)=>{
      console.log(e);
      setLoading(false);
      enqueueSnackbar('Enter Required Fields ',{variant:'error'});
     })
     
   }
const init = async () => {
  let res = await axios(`${Baseurl}/getuser?id=${userid}`,{withCredentials:true})
if(res){
  setAdress(res?.data?.address?.[0].addrr)
}
  
}
useEffect(() => {
 init()
},[])

  return (

    
    <div  style={{height:'100vh',flexGrow:'1'}}>

      <main className='main'>
      <section className='section-inner-page'>
  
  
    <div className="container" >

<div className='order-form'>
     <div className="row">
       <div className="col-md-12 text-center mt-4">
       
        {Loading ? <Loadersspinners /> : <div><h2>Order Form</h2></div> }
       </div>
     
     </div>

     <div className="row">
       <div className="col-md-12">
         <div className='mt-1 w-100'>
         <form method='post'  onSubmit={submitdata} >
       
       <input name='userid' hidden readOnly defaultValue={userid}  type='textarea'></input>
         
         <div className=' mt-5'>
         <label className=' form-label'>Adress: </label>
         <textarea className='form-control' rows={5} value={adress}   name='adress'onChange={(e)=>{setAdress(e.target.value)}} type='textarea'></textarea>
        
         </div>

         <div className=' mt-3 '>
         <label className='form-label'>Phone Number </label>
         <input className='form-control'  name='mobile' min="0" onChange={(e)=>{setPhone(e.target.value)}} type='number'></input>
        
         </div>

         <div className='mt-3 '>
         <label className='form-label' >Payment Method </label>

         <div className='d-flex'>
         <input className='me-1'   name='paymentMethod'  onChange={(e)=>{setRadio('cod')}} value='cod' type='radio'></input> COD
         <input className='me-1'   style={{marginLeft:'12px'}}  name='paymentMethod' value='online' onChange={(e)=>{setRadio('online')}} type='radio'></input> Online
        
         </div>
         </div>

         <input className='mt-3' name='totalprice' hidden readOnly defaultValue={totalprice}  type='text'></input>
 
         <div className='mt-4' >
         <small >Total Price $.</small><span className='pe-2' style={{fontSize:'30px'}}> {totalprice}</span> 

         <hr/>
         <Button  disabled={Loading || !adress ||!radio ||!phone} className='btn-primary-theme'  type='submit' onClick={submitdata}>
         {radio === 'online' ? 
         <Payment 
          userid={userid} 
          totalprice={totalprice}
          adress={adress}
          phone={phone}
          setRadio={setRadio} 
        />  : <span className='text-white'> Check Out </span>}   
         </Button>

        </div>  
       </form>
         </div>
         
       </div>
     </div>
  </div> 
  </div>
  </section>
  </main>
  </div> 
  
  
   
  )
}

export default Orderform
